import { Box, IconButton, Typography } from "@mui/material";

import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import DialogComponent from "../dialogs/DialogComponent";
import { NO_DRAG_SELECTOR } from "../../../../app/constants";
import { Heading3 } from "../../styled/styled";
import { SpinnerButton } from "../spinnerButton/SpinnerButton";
import theme from "../../../../theme";
import { GridCloseIcon } from "@mui/x-data-grid-pro";
import { isFulfilled, PayloadAction } from "@reduxjs/toolkit";

export interface TempPasswordUpdated {
  events: any[];
  tempPassword: string;
}

interface Props {
  isOpen: boolean;
  userName: string;
  userEmail: string;
  // TODO type properly
  onSetTempPassword: () => Promise<void> | Promise<PayloadAction<any>>;
  close: () => void;
}

export const TempPasswordDialog = ({
  isOpen,
  userName,
  userEmail,
  onSetTempPassword,
  close,
}: Props) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [hasBeenExecuted, setHasBeenExecuted] = useState(false);
  const [tempPassword, setTempPassword] = useState<string | undefined>();

  const onSubmit = () => {
    setIsLoading(true);
    onSetTempPassword().then((action) => {
      if (isFulfilled(action)) {
        const payload = action.payload as TempPasswordUpdated;
        setTempPassword(payload.tempPassword);
      }
      setIsLoading(false);
      setHasBeenExecuted(true);
    });
  };

  useEffect(() => {
    if (!isOpen) {
      setHasBeenExecuted(false);
      setTempPassword(undefined);
    }
  }, [isOpen]);

  return (
    <DialogComponent
      open={isOpen}
      onClose={() => {
        close();
      }}
    >
      <Box width="100%" className={NO_DRAG_SELECTOR}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Heading3>{t("settings:resetPassword")}</Heading3>
          <IconButton
            onClick={() => {
              close();
            }}
          >
            <GridCloseIcon />
          </IconButton>
        </Box>
        <Box mt={2}>
          <Trans
            i18nKey="settings:resetUserPasswordInfo"
            values={{
              name: userName,
              email: userEmail,
            }}
          />
        </Box>
        <Box mt={2}>
          <SpinnerButton
            label={t("settings:generateTempPassword")}
            onClick={onSubmit}
            variant="contained"
            isLoading={isLoading}
            disabled={isLoading || hasBeenExecuted}
            color="primary"
            sx={{ height: "36px", borderRadius: "20px" }}
            spinnerSx={{ color: theme.palette.primary.main }}
          />
        </Box>
        {hasBeenExecuted && !isLoading && (
          <Box mt={2}>
            {tempPassword ? (
              <>
                <Typography>{t("settings:password")}</Typography>
                <pre>{tempPassword}</pre>
              </>
            ) : (
              <Typography>{t("common:UNSPECIFIED_ERROR")}</Typography>
            )}
          </Box>
        )}
      </Box>
    </DialogComponent>
  );
};
